/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DrawIcon = ({ width = 24, height = 24, hidden = false, title = 'Draw' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M20.454 8 5.084 23.372a.992.992 0 0 0-.251.421L2.055 33.1c-.114.376.459.85.783.85a.311.311 0 0 0 .062-.006c.276-.064 7.867-2.344 9.311-2.778a.984.984 0 0 0 .415-.25L28 15.544ZM11.4 29.316c-2.161.649-4.862 1.465-6.729 2.022l2.009-6.73ZM33.567 8.2 27.8 2.432a1.215 1.215 0 0 0-.866-.353H26.9a1.372 1.372 0 0 0-.927.407l-4.1 4.1 7.543 7.543 4.1-4.1a1.372 1.372 0 0 0 .4-.883 1.224 1.224 0 0 0-.349-.946Z"
    />
  </svg>`;
};
